import React from 'react';
import { observer } from 'mobx-react-lite';

import { Badge, IBadgeProps } from '../common/Badge';
import { Tag } from '@models/Tags/TagModel';

export const TAG_ITEM_HEIGHT = 35;

export interface ITagItemProps extends Pick<IBadgeProps, 'isActive'> {
  onPress(item: Tag): void;
  item: Tag;
}

export const TagItem = observer(
  ({ onPress, item, isActive }: ITagItemProps) => {
    function innerOnPress() {
      onPress(item);
    }

    return (
      <Badge isActive={isActive} onPress={innerOnPress}>
        {item.name}
      </Badge>
    );
  },
);
